import { IconButton, InputAdornment, TextField, Button, Stack } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as Style from "./MarketingMaterialsSearchBar.styles.ts";

interface MarketingMaterialsSearchBarProps {
	value: string;
	placeholder: string;
	helperText?: string;
	searchButtonLabel?: string;
	onChange: (value: string) => void;
	onSearch: () => void;
	onClear: () => void;
}

export const MarketingMaterialsSearchBar = ({
	value,
	placeholder,
	helperText,
	searchButtonLabel = "SEARCH",
	onChange,
	onSearch,
	onClear
}: MarketingMaterialsSearchBarProps) => {
	const hasValue = value.trim().length > 0;

	return (
		<Style.MarketingMaterialsSearchContainer>
			<Style.MarketingMaterialsSearchInputLine>
				<Stack spacing={1}>
					<Stack
						direction="row"
						spacing={1}
					>
						<TextField
							fullWidth
							placeholder={placeholder}
							value={value}
							onChange={(e) => onChange(e.target.value)}
							onKeyDown={(e) => {
								if (e.key === "Enter") onSearch();
							}}
							size="small"
							data-testid="marketing-materials-search-input"
							slotProps={{
								inputLabel: { required: false, shrink: true },
								input: {
									endAdornment: hasValue ? (
										<InputAdornment position="end">
											<IconButton
												edge="end"
												onClick={onClear}
												data-testid="marketing-materials-search-clear"
												aria-label="clear search"
											>
												<CloseIcon />
											</IconButton>
										</InputAdornment>
									) : undefined
								}
							}}
						/>

						<Button
							variant="contained"
							onClick={onSearch}
							data-testid="marketing-materials-search-button"
						>
							{searchButtonLabel}
						</Button>
					</Stack>

					{helperText ? <span>{helperText}</span> : null}
				</Stack>
			</Style.MarketingMaterialsSearchInputLine>
		</Style.MarketingMaterialsSearchContainer>
	);
};
